import { PageContainer } from "../../../../components/common/page-container";
import { Heading } from "../../../../components/common/typography";
import { LoyaltyPromotionsSection } from "../components/loyalty-promotions-section";

/** Admin loyalty points promotions: list, create, edit, delete campaigns. */
export function AdminLoyaltyPromotionsPage() {
  return (
    <PageContainer>
      <div className="flex flex-col gap-6">
        <Heading variant="h2" tone="dark">
          Loyalty Promotions
        </Heading>
        <LoyaltyPromotionsSection />
      </div>
    </PageContainer>
  );
}
